import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';
import { UtilsService } from './services/Utils/utils.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'RepositoryFE';

  constructor(private dialog: MatDialog, public utils: UtilsService) {
    this.dialog.afterOpen.subscribe((dialogRef) => {
      let onEscKeyDownSubscription: Subscription = dialogRef.keydownEvents().subscribe(event => {
        if (event.key === "Escape") {
          if (!utils.isLoading() && !utils.isDialogUnclosable()) {
            event.preventDefault();
            dialogRef.close();
          }
        }
      });

      let onBackdropClickSubscription: Subscription = dialogRef.backdropClick().subscribe((event) => {
        if (!utils.isLoading() && !utils.isDialogUnclosable()) {
          event.preventDefault();
          dialogRef.close();
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        onEscKeyDownSubscription.unsubscribe();
        onBackdropClickSubscription.unsubscribe();
      })
    });
  }
}
